export default __webpack_public_path__ + "static/media/background.23553775.png";